import React from "react";
import { useNavigate } from "react-router-dom";
import { Divider, Button } from "@mui/material";
import routes from "../../routes";
import { StyledApplicationErrorHeader, StyledApplicationError } from "./styled";
import { ReactComponent as LogoSmallColor } from "../../assets/images/logo-small-color.svg";
import useRedirectionUrl from "../../utils/useRedirectionUrl";

//ro-assist-brd2-3
const accountComparisionRoute = {
  link: routes.quickapplyLanding,
  label: "Back to home"
};
const getFirstLine = text => {
  let index = text.indexOf("$");
  if (index === -1) {
    index = undefined;
    return "";
  } else {
    return text.substring(0, index);
  }
};
const getScondLine = text => {
  let index = text.indexOf("$");
  if (index === -1) {
    index = undefined;
    return text;
  } else {
    return text.substring(index + 1);
  }
};

export const ApplicationError = ({
  icon,
  text,
  link,
  screeningType = "",
  buttons = [accountComparisionRoute],
  isEFRDeclinedScreen = false
}) => {
  const navigate = useNavigate();
  const { redirectToExternalURL } = useRedirectionUrl();

  const redirectTo = (route, external) => {
    if (external) {
      window.location.href = route;
    } else {
      navigate(route);
      window.location.reload();
    }
  };

  const buttonClass = buttons.length > 1 ? "appErrorMultipleLink" : "appErrorLink";

  const navigateToBAU = () => {
    const externalURL = process.env.REACT_APP_BAU_URL + "/business/applicantinfo-redirect";
    const url = redirectToExternalURL(externalURL);
    window.location.href = url;
  };

  let declineMessage;

  if (isEFRDeclinedScreen) {
    declineMessage = (
      // Assigning data-testid="EFR_CHECK_ERROR" to the div for easier searching
      <div className={"info"} data-testid="EFR_CHECK_ERROR">
        Dear Customer, we were unable to complete your facial recognition process successfully. Not
        to worry! You may still proceed with our alternative application platform by clicking this
        secure link.&nbsp;
        <span
          className="externalLink"
          onClick={() => navigateToBAU()}
          data-testid="EFRDeclineNavigateToBAULink"
        >
          Click here
        </span>
      </div>
    );
  } else {
    declineMessage = <div className={"info"} dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return (
    <>
      <StyledApplicationErrorHeader className={"small-menu-show"}>
        <LogoSmallColor />
      </StyledApplicationErrorHeader>
      <StyledApplicationError>
        <div className={"appErrorStatus"}>
          <div className={"errorMessage"}>
            {screeningType !== 403 ? (
              <>
                <div className={"title"}>{getFirstLine(text)}</div>
                <p className={"subTitle"}>{getScondLine(text)}</p>
              </>
            ) : (
              <>
                <div className={"title"}>
                  {"Thank You for choosing our bank assisted application process"}
                </div>
                {declineMessage}
              </>
            )}

            <Divider className={"divider"} />
          </div>
          {/* ro-assist-brd2-3 */}
          {link && (
            <div className={"linkErrorWrapper"}>
              {buttons.map((btn, index) => (
                <Button
                  key={index}
                  onClick={() => redirectTo(btn.link, btn.external)}
                  className={buttonClass}
                >
                  {btn.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </StyledApplicationError>
    </>
  );
};
